/*
 * @Author: your name
 * @Date: 2020-09-24 13:19:16
 * @LastEditTime: 2020-12-03 17:22:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qh-wbactive\src\page\marketact\services\apis.js
 */
export default {
    // 公众号黄历
    gettodaydaigram: '/v1/home/gettodaydaigram',
    // 公众号每日图片
    getDailyCoverUrl: '/v1/home/dailyCover'
};
